import React from 'react';
import { createPortal } from 'react-dom';
import { useToastContext } from './ToastContext';
import Toast from './ToastItem';

import './Toast.scss';

const ToastContainer = () => {
  const { toasts, removeToast } = useToastContext();

  if (toasts.length === 0) return null;

  return createPortal(
    <div className="otos-toast-container" aria-live="polite" aria-atomic="false">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          type={toast.type}
          message={toast.message}
          isExiting={toast.isExiting}
          onClose={removeToast}
        />
      ))}
    </div>,
    document.body
  );
};

export default ToastContainer;
